import React from 'react';
import styled from '@benzinga/themetron';
import { NewsGrid } from '@benzinga/news';
import { News } from '@benzinga/basic-news-manager';

export interface NewsGridProps {
  attrs: {
    data?: {
      title?: string;
      subtitle?: string;
      nodes?: News[];
    };
  };
}

export const NewsGridBlock: React.FC<NewsGridProps> = ({ attrs }) => {
  const nodes = attrs?.data?.nodes || [];
  const title = attrs?.data?.title;
  const subtitle = attrs?.data?.subtitle;
  return (
    <NewsGridWrapper>
      <NewsGrid nodes={nodes} subtitle={subtitle} title={title} />
    </NewsGridWrapper>
  );
};

export const NewsGridWrapper = styled.div`
  margin: 1rem auto;
`;
